const apiEndpoints = {
  loginWallet: 'user/login/wallet',
  verifyChallenge: 'user/verify-challenge',
  baseUrl: process.env.REACT_APP_API_NEST_URL,
};

export default apiEndpoints;
